import type { RouteObject } from 'react-router-dom';

import { ChatbotSettingsPage } from './ui/pages/ChatbotSettingsPage';
import { ChatbotTemplatesPage } from './ui/pages/ChatbotTemplatesPage';

/**
 * Chatbot-settings route entries, mounted as children of `store-settings`'s `settingsRoutes`
 * (relative to `/settings`, inside its `RequireSection section="settings"` guard — the page itself
 * gates further on `settings.chatbot.*`/`content.*`, exactly like `languages` does on
 * `catalog.structure.*`). `chatbot` additionally has a `<RequireSection>` shortcut of its own under
 * Customers (`AppLayout.NAV_SECTIONS`, `APP_SECTIONS.chatbot`) — `routeGuardCoverage.test.tsx`
 * records it as covered by this same `settings` guard, the `messaging` precedent.
 */
export const chatbotSettingsRoutes: RouteObject[] = [
  { path: 'chatbot', element: <ChatbotSettingsPage /> },
  { path: 'chatbot/templates', element: <ChatbotTemplatesPage /> },
];
